module.exports = __webpack_public_path__ + "img/email.fb4450e9.svg";